<template>
  <div id="document">
    <Header></Header>
    <Navi currentPage="download" :naviHeight="naviH"></Navi>
    <div class="main_doc" id="main">
        <!-- <Doc :paras="paras" class="doc"></Doc> -->
        <div class="cont">
            <h2 style="color: #006652;">GEC Application and Manual (Latest)</h2>
            <Table :headers="download_head" :records="download_records" class="download_table"></Table>
            <h2 style="color: #006652;">Disclaimer</h2>
            <p>GEC is free of charge. All materials on the website are provided without any warranty. 
                Please use them at your own risk.</p>
            <h2 style="color: #006652;">Updates</h2>
            <div v-for="rec of updates">
                <div class="update_title">
                    <img :src="updateImg" class="update_ico"><p>{{rec[0]}}</p>
                </div>
                <div class="update_content">
                    <p v-html="rec[1]"></p>
                </div>
            </div>
            <h2 style="color: #006652;">Archive</h2>
            <Table :headers="download_head" :records="archive" class="download_table"></Table>
        </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import Doc from '@/components/doc.vue'
import Table from '@/components/table.vue'
import UpdateImg from '@/assets/img/update.png'

import {api_dir} from '@/bus.js'
import axios from 'axios/dist/axios.min';
// import EleDoc from '@/components/eledoc.vue'
export default {
    name: 'download',
    components: {Navi,Footer,Doc,Header,Table},
    data:function(){
        return {
            download_head:['Type','File','Description','Size','Version'],
            download_records:[
                // ['Java package and examples','<a style="color:#006652;" href="data/archive/v0.2/gecV0.2.zip">gec.zip</a>',
                // 'Java package of KGGSEE, with examples of GEC function','39.2 MB','1.0'],
                ['Java package','<a style="color:#006652;" href="data/archive/v1.0/kggsee.jar">kggsee.jar</a>',
                'Java package of KGGSEE','29.6 MB','1.0'],
                ['Manual','<a style="color:#006652;" href="data/archive/v1.0/UserManualV1.pdf">UserManualV1.pdf</a>',
                'Manual of GEC function','158 KB','1.0'],
            ],
            updates:[
                ['2021-02-02',' The GEC method has been implemented in <a style="color:#006652" href="http://pmglab.top/kggsee">KGGSEE</a> software tool.'],
                ['2015-10-03','Allow the use of 1000 Genomes Project\'s VCF genotype as reference LD, which can be downloaded from <a style="color:#006652" href="http://pmglab.top/genotypes">here</a>.'],
                ['2015-6-12','Fixed a minor bug in the function of using Genomes Project\'s VCF genotype as reference LD.'],
            ],
            updateImg:UpdateImg,
            naviH:'',
            archive:[
                ['Java package and examples','<a style="color:#006652;" href="data/archive/v0.2/gecV0.2.zip">GEC.zip</a>',
                'Java package of GEC','3.32 MB','0.2'],
                ['Manual','<a style="color:#006652;" href="data/archive/v0.2/UserManualV0.2.pdf">User manual</a>',
                'Manual of GEC','626 KB','0.2'],
            ],
        }
    },
    watch:{
        updates:function(){
             var _this = this;
            _this.$nextTick(function () {
                _this.getHeigth()
            });
        }
    },
    mounted () {
        // this.getData()
        this.getHeigth()
    },
    methods:{
        getHeigth(){
            var h = document.getElementById('main').clientHeight;
            console.log(h)
            // if (h<400){
            //     h=400
            // }
            this.naviH=h+'px'
            // document.getElementById('main').style.height=this.naviH
        }
    }

}
</script>

<style scoped>
.main_doc{
    width: 960px;
    border: solid #E1EAEA 1px;
    position: relative;
  top:85px;
  bottom: 10px;
  left: 205px;
  /* height: 600px; */
  margin-left: 15px;
  margin-top: 10px;
  padding-bottom: 10px;
}
.cont{
    margin-top: 25px ;
    margin-left: 30px;
	vertical-align: middle;
}

p {
    color: #000000;
    line-height: 15px;
    font-size: 15px;
    margin:5px 0px;
    padding-left: 8px;
}

h2{
    font-size: 20px;
    line-height: 20px;
    margin:15px 0px;
}

a{
    color:#006652;
}

.download_table{
    width: 850px;
    margin: 10px ;
}
.update_ico{
    height: 18px;
    float: left;
    margin-right: 5px;
    margin-top: 1px;
}

.update_content,.update_title{
    width: 800px;

}

.update_title p{
    font-weight: bold;
    background: #E0E7D8;
    font-size: 15px;
    line-height: 20px;
}

.update_content p{
    margin-left: 15px;
    font-size: 14px;
}

</style>


// WEBPACK FOOTER //
// src/views/download.vue